import * as Sentry from '@sentry/react';

import { apiRequest } from '@/api/ApiUtils';
//import { DefaultApi } from '@/api/prst';
import { DefaultApi } from '@/api/creation';
import { FetchPRSTListResponse, FetchPRSTQueryParamater } from '@/types/PRST';
import { axiosInstance } from '@/utils/axiosInstance';

import { PostCreationAccountInput, PostMeasureInput } from '../api/creation/api';

const api = new DefaultApi(undefined, undefined, axiosInstance);

// 案件一覧取得API
export const fetchPRSTListInfo = async (query: FetchPRSTQueryParamater): Promise<FetchPRSTListResponse> => {
  const queryParam = {};
  query.status && Object.assign(queryParam, { status: query.status.toString() });
  Object.assign(queryParam, { rows: query.rows.toString() });
  Object.assign(queryParam, { page: query.page.toString() });
  Object.assign(queryParam, { order: query.order.toString() });
  if (query.noChache) {
    Object.assign(queryParam, { date: new Date().toISOString() });
  }
  query.orderBy && Object.assign(queryParam, { orderBy: query.orderBy.toString() });
  const queryString = new URLSearchParams(queryParam).toString();
  return apiRequest<FetchPRSTListResponse>(`/projects/prst?${queryString}`, {
    method: 'GET',
  });
};

/**
 *【Mock】制作管理施策登録API
 */
export const registerProductManagement = async (accountId: string, postMeasureInput: PostMeasureInput) => {
  try {
    const response = await api.postMeasure(accountId, postMeasureInput);
    return response.data;
  } catch (error: any) {
    Sentry.captureException(error);
    // Errorをキャッチしないとそのままthrowされるので、エラーをハンドリングした場合はここでキャッチしてthrowする
    throw new Error(`HTTP error! status: ${error.response.status}, text: ${error.response.data.messages?.join(', ')}`);
  }
};

/**
 *【Mock】制作管理施策削除API
 */

export const deleteProductManagement = async (id: string) => {
  try {
    const response = await api.deleteMeasure(id);
    return response.data;
  } catch (error: any) {
    Sentry.captureException(error);
    // Errorをキャッチしないとそのままthrowされるので、エラーをハンドリングした場合はここでキャッチしてthrowする
    throw new Error(`HTTP error! status: ${error.response.status}, text: ${error.response.data.messages?.join(', ')}`);
  }
};

/**
 *【Mock】制作管理アカウント登録API
 */
export const registerSnsAccount = async (postMeasureInput: PostCreationAccountInput) => {
  try {
    const response = await api.postCreationAccount(postMeasureInput);
    return response.data;
  } catch (error: any) {
    Sentry.captureException(error);
    // Errorをキャッチしないとそのままthrowされるので、エラーをハンドリングした場合はここでキャッチしてthrowする
    throw new Error(`HTTP error! status: ${error.response.status}, text: ${error.response.data.messages?.join(', ')}`);
  }
};

/**
 * 【Mock】制作管理アカウント一覧取得API
 */
export const fetchSnsAccountList = async () => {
  try {
    const response = await api.getCreationAccounts();
    return response.data;
  } catch (error: any) {
    Sentry.captureException(error);
    // Errorをキャッチしないとそのままthrowされるので、エラーをハンドリングした場合はここでキャッチしてthrowする
    throw new Error(`HTTP error! status: ${error.response.status}, text: ${error.response.data.messages?.join(', ')}`);
  }
};
